export const convertToCSV = (data, columns) => {
  const headers = columns.map(col => `"${col.label}"`).join(',');
  const rows = data.map(item => {
      return columns.map(col => {
          // Safely access nested properties using the 'value' key (e.g., 'customer.name')
          let cellData = col.value.split('.').reduce((obj, key) => (obj && obj[key] !== undefined) ? obj[key] : '', item);
          
          if (cellData === null || cellData === undefined) {
              cellData = '';
          }
          
          let stringCellData = String(cellData);
          if (stringCellData.includes('"') || stringCellData.includes(',') || stringCellData.includes('\n')) {
              stringCellData = `"${stringCellData.replace(/"/g, '""')}"`;
          }
          return stringCellData;
      }).join(',');
  });
  return `${headers}\n${rows.join('\n')}`;
};

export const downloadCSV = (csvContent, fileName) => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `${fileName}-export.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};